/* Page de Noël — comportement.
   Galerie, offres, jauge de livraison, date estimée, date limite, portes,
   barre fixe, panier.

   Ce fichier est un asset : il n'est PAS interprété par Liquid. C'est
   volontaire — les accolades doubles des formats monétaires Shopify
   ({{amount}}) seraient sinon avalées par Liquid. La configuration arrive
   par le script JSON posé dans la section. */
(function () {
  var root = document.querySelector(".xmas");
  if (!root) return;

  var cfgEl = document.querySelector("[data-xmas-config]");
  var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var FMT = CFG.moneyFormat || "${{amount}}";
  var SHIP = CFG.shipCents || 0;
  var R = CFG.routes || {};
  var STR = CFG.strings || {};
  var LOCALE = CFG.locale || "en-US";

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return FMT
      .replace(/\{\{\s*amount\s*\}\}/, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  }
  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); }

  /* ---------- galerie ---------- */
  var main = $("[data-gal-main]");
  var thumbs = $$("[data-thumb]");
  function pick(t) {
    var full = t.getAttribute("data-full");
    if (main && full) {
      main.src = full;
      var srcset = t.getAttribute("data-srcset");
      if (srcset) main.srcset = srcset;
      main.alt = t.getAttribute("data-alt") || "";
    }
    thumbs.forEach(function (o) { o.setAttribute("aria-current", o === t ? "true" : "false"); });
  }
  thumbs.forEach(function (t) { t.addEventListener("click", function () { pick(t); }); });

  /* ---------- état de l'offre ---------- */
  var radios = $$('input[name="xmas-bundle"]');
  var prot = $("[data-prot]");

  function chosen() {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
    return radios[0];
  }

  function sync() {
    var r = chosen();
    if (!r) return;
    var price = parseInt(r.getAttribute("data-price"), 10) || 0;
    var was = parseInt(r.getAttribute("data-compare"), 10) || 0;
    var name = r.getAttribute("data-name") || "";
    var total = price + (prot && prot.checked ? (parseInt(prot.getAttribute("data-price"), 10) || 0) : 0);

    $$("[data-hero-o1]").forEach(function (el) { el.textContent = name; });
    $$("[data-hero-o2]").forEach(function (el) { el.textContent = money(price); });
    var ht = $("[data-hero-total]");
    if (ht) ht.textContent = STR.total ? STR.total + " " + money(total) : money(total);
    var amt = $("[data-cta-amt]");
    if (amt) amt.textContent = " · " + money(total);

    /* Jauge de livraison offerte du bloc d'achat : elle réagit à l'offre
       choisie ET à la protection, comme le total. */
    var left = SHIP - total;
    var fsTxt = $("[data-fs-txt]"), fsAmt = $("[data-fs-amt]"), fsFill = $("[data-fs-fill]");
    if (fsTxt) fsTxt.textContent = left <= 0 ? (STR.free || "") : (STR.away || "").replace("[amount]", money(left));
    if (fsAmt) fsAmt.textContent = left <= 0 ? "" : money(total) + " / " + money(SHIP);
    if (fsFill) fsFill.style.width = Math.min(100, SHIP ? (total / SHIP) * 100 : 100) + "%";

    var sn = $("[data-st-name]"), snow = $("[data-st-now]"), swas = $("[data-st-was]");
    if (sn) sn.textContent = name;
    if (snow) snow.textContent = money(total);
    /* Prix barré affiché uniquement s'il existe vraiment sur la variante. */
    if (swas) swas.textContent = was > price ? money(was) : "";
  }

  radios.forEach(function (r) { r.addEventListener("change", sync); });
  if (prot) prot.addEventListener("change", sync);
  sync();

  /* ---------- date de livraison estimée ----------
     Jours ouvrés uniquement : on saute samedis et dimanches. */
  (function () {
    var el = $("[data-delivery]");
    if (!el) return;
    var days = parseInt(CFG.leadDays, 10);
    if (isNaN(days) || days < 0) return;
    var d = new Date();
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    var txt;
    try { txt = d.toLocaleDateString(LOCALE, { weekday: "long", month: "long", day: "numeric" }); }
    catch (e) { txt = d.toDateString(); }
    el.textContent = (STR.delivery || "").replace("[date]", txt);
  })();

  /* ---------- date limite d'expédition ---------- */
  (function () {
    var el = $("[data-deadline]");
    if (!el) return;
    var raw = CFG.deadline;
    if (!raw) { el.hidden = true; return; }
    var end = new Date(raw + "T23:59:59");
    if (isNaN(end.getTime())) { el.hidden = true; return; }
    var days = Math.ceil((end - new Date()) / 864e5);
    var slot = $("[data-deadline-txt]", el) || el;
    if (days <= 0) {
      slot.textContent = STR.deadlinePast || "";
      return;
    }
    var dtxt;
    try { dtxt = end.toLocaleDateString(LOCALE, { month: "long", day: "numeric" }); }
    catch (e) { dtxt = raw; }
    slot.innerHTML = (STR.deadline || "")
      .replace("[date]", "<b>" + dtxt + "</b>")
      .replace("[days]", "<b>" + days + "</b>");
  })();

  /* ---------- les 24 portes ----------
     Le retournement est purement CSS ; le script ne fait que basculer
     aria-expanded, qui sert à la fois d'état visuel et d'information
     d'accessibilité. */
  $$(".door").forEach(function (b) {
    b.addEventListener("click", function () {
      b.setAttribute("aria-expanded", b.getAttribute("aria-expanded") === "false" ? "true" : "false");
    });
  });

  /* ---------- barre fixe ---------- */
  var sticky = $("[data-sticky]");
  var anchor = $("[data-buybox]") || $("#offers");
  function stickyOn(v) {
    if (!sticky) return;
    sticky.classList.toggle("on", v && !document.body.classList.contains("xmas-lock"));
  }
  if (sticky && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) {
      stickyOn(e[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---------- panier ---------- */
  var drawer = $("[data-drawer]"), scrim = $("[data-scrim]"), lastFocus = null;

  /* .drawer est en display:flex, ce qui neutralise l'attribut [hidden] : sans
     ça le panier fermé reste dans l'ordre de tabulation et dans l'arbre
     d'accessibilité. On pilote donc display explicitement. */
  function hide(el) { if (el) { el.hidden = true; el.style.display = "none"; } }
  function show(el) { if (el) { el.hidden = false; el.style.display = ""; } }
  hide(drawer); hide(scrim);

  function lock(on) {
    document.body.classList.toggle("xmas-lock", on);
    if (on) stickyOn(false);
  }
  function openCart() {
    lastFocus = document.activeElement;
    show(drawer); show(scrim);
    requestAnimationFrame(function () { drawer.classList.add("on"); scrim.classList.add("on"); });
    lock(true);
    var c = $("[data-close]"); if (c) c.focus();
  }
  function closeCart() {
    drawer.classList.remove("on"); scrim.classList.remove("on");
    lock(false);
    setTimeout(function () { hide(drawer); hide(scrim); }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (scrim) scrim.addEventListener("click", closeCart);
  var closeBtn = $("[data-close]");
  if (closeBtn) closeBtn.addEventListener("click", closeCart);
  var openBtn = $("[data-open-cart]");
  if (openBtn) openBtn.addEventListener("click", function (e) { e.preventDefault(); refresh().then(openCart); });

  document.addEventListener("keydown", function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === "Escape") { closeCart(); return; }
    if (e.key !== "Tab") return;
    var f = $$('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])', drawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  function renderCart(cart) {
    var body = $("[data-cart-body]");
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="empty">' + esc(STR.empty) + "</p>";
    } else {
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "";
        return '<div class="li">' +
          (img ? '<img src="' + esc(img) + '" alt="" width="58" height="58">' : "") +
          '<div class="li-t"><b>' + esc(it.product_title) + "</b>" +
          (it.variant_title && it.variant_title !== "Default Title" ? "<span>" + esc(it.variant_title) + "</span>" : "") +
          '<div class="qty">' +
          '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="' + esc(STR.less) + '">–</button>' +
          "<span>" + it.quantity + "</span>" +
          '<button type="button" data-line="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="' + esc(STR.more) + '">+</button>' +
          "</div></div>" +
          "<div><b>" + money(it.final_line_price) + "</b></div></div>";
      }).join("");
    }

    var tot = $("[data-cart-total]");
    if (tot) tot.textContent = money(cart.total_price);

    var pip = $("[data-cart-count]");
    if (pip) pip.textContent = cart.item_count;

    var left = SHIP - cart.total_price;
    var shipEl = $("[data-ship]");
    if (shipEl) shipEl.textContent = left <= 0 ? (STR.free || "") : (STR.away || "").replace("[amount]", money(left));
    var bar = $("[data-bar]");
    if (bar) bar.style.width = Math.min(100, SHIP ? (cart.total_price / SHIP) * 100 : 100) + "%";

    $$("[data-line]", body).forEach(function (b) {
      b.addEventListener("click", function () {
        change(b.getAttribute("data-line"), parseInt(b.getAttribute("data-q"), 10));
      });
    });
  }

  function refresh() {
    return fetch(R.cart + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }
  function change(key, qty) {
    return fetch(R.change + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  var busy = false;
  function add() {
    if (busy) return;
    var r = chosen();
    if (!r) return;
    busy = true;
    var items = [{ id: parseInt(r.value, 10), quantity: 1 }];
    if (prot && prot.checked) items.push({ id: parseInt(prot.value, 10), quantity: 1 });

    fetch(R.add + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) { if (!res.ok) throw new Error("add"); return res.json(); })
      .then(function () { return refresh(); })
      .then(function () { openCart(); })
      .catch(function () { window.location.href = R.cart; })
      .then(function () { busy = false; });
  }
  $$("[data-add]").forEach(function (b) { b.addEventListener("click", add); });
})();